import React from 'react';
import { ReactJsonView } from 'react-scale/corp/components/ReactJsonView';
import { copyToClipboard } from '@scale/frontend-lib/clipboard';
import { Button } from '@scale/scaleui';

interface LookupJSONProps {
  lookup_json: any;
  name?: string;
  downloadButton?: boolean;
  extraProps?: Record<string, any>;
}

const LookupJSON: React.FC<LookupJSONProps> = ({
  lookup_json,
  name = 'lookup_json',
  downloadButton = true,
  extraProps = {},
}) => {
  const handleDownloadJSON = () => {
    const jsonString = JSON.stringify(lookup_json, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'lookup.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-8">
      <div className="w-full rounded-lg shadow-sm bg-neutral-0 overflow-hidden">
        <div className="p-8 relative">
          {downloadButton && (
            <div className="absolute top-8 right-8 z-10">
              <Button variant="outline" onClick={handleDownloadJSON} size="sm">
                Download JSON
              </Button>
            </div>
          )}
          <ReactJsonView
            style={{
              wordBreak: 'break-all',
            }}
            src={lookup_json}
            enableClipboard={copy => {
              const jsonString = JSON.stringify(copy.src, null, 2);
              copyToClipboard(jsonString, { copyRaw: true });
              return true;
            }}
            collapsed={1}
            name={name}
            displayDataTypes={false}
            displayObjectSize={false}
            collapseStringsAfterLength={120}
            groupArraysAfterLength={false}
            {...extraProps}
          />
        </div>
      </div>
    </div>
  );
};

export default LookupJSON;
